/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */

export type CurrentUserApiResourceType = typeof CurrentUserApiResourceType[keyof typeof CurrentUserApiResourceType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CurrentUserApiResourceType = {
  admin: 'admin',
  manager: 'manager',
  owner: 'owner',
  guest: 'guest',
  vendor: 'vendor',
  system: 'system',
} as const;
